// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'check';

export const Component = () => (
  <path d='m3.464 11.371 6.222 5.974L21.582 5 23 6.371 9.732 20 2 12.743l1.464-1.372Z' />
);

export const viewBox = '0 0 25 25';
